module.exports = __webpack_public_path__ + "static/media/AoA_RaceGameEnvShot_19.17f5b256.jpg";